import React from 'react';

const commonStyle = "inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors ease-in-out disabled:pointer-events-none disabled:opacity-50";
const variants = {
  primary: `bg-primaryButton text-themeColor border border-primaryButton px-[35px] py-[6px] rounded-[4px] lg:rounded-[8px] text-[16px] font-[400] leading-[normal]
              hover:bg-primaryHeading hover:text-themeColor
    `,
  primaryOutlined: `bg-primaryButton text-themeColor border border-primaryButton px-[40px] py-[12px] rounded-[4px] lg:rounded-[8px] text-[16px] font-[400] leading-[normal] 
              md:px-[35px] md:py-[8px] md:text-[17px]
    `,
  primaryOutline: `bg-primaryButton text-themeColor border border-primaryButton rounded-[4px] lg:rounded-[8px] text-[16px] font-[400] leading-[normal]
              hover:bg-white hover:text-primaryButton
              !md:px-[35px] !md:py-[8px] md:text-[17px]
    `,
  theme: `bg-primaryHeading text-white px-[25px] py-[8px] rounded-[4px] lg:rounded-[8px] text-[16px] font-[400] leading-[normal] hover:opacity-80
            md:px-[35px] md:py-[8px] md:text-[17px]
    `,
  lighttheme: `bg-themeColor text-white px-[25px] py-[8px] rounded-[4px] lg:rounded-[8px] text-[16px] font-[400] leading-[normal]
            md:px-[35px] md:py-[8px] md:text-[17px]
    `,
  redeem: `bg-rewardsPrimaryColor text-darkColor px-[15px] py-[7px] rounded-[4px] lg:rounded-[8px] text-[14px] font-[400] leading-[normal]
    `,
  secondary: `bg-white text-themeColor px-[25px] py-[8px] rounded-[4px] lg:rounded-[8px] text-[16px] font-[400] leading-[normal]
                hover:opacity-80
                md:px-[35px] md:py-[10px] md:text-[17px] 
    `,
  default: `bg-primary text-primary-foreground
              hover:bg-primary/90
    `,
  destructive: `bg-destructive text-destructive-foreground
                  hover:bg-destructive/90
    `,
  outline: `border border-[#fff] bg-transparent rounded-[4px] lg:rounded-[8px]
              hover:bg-[#FFF] hover:text-themeColor
    `,
  ghost: `hover:bg-accent hover:text-accent-foreground`,
  link: `text-primary underline-offset-4
           hover:underline
    `,
  cancel: `bg-cancelButton text-white rounded-[4px] lg:rounded-[8px] min-w-[100px] max-w-[200px] px-[10px] py-[3px]
             hover:opacity-80
    `,
  text: `bg-transparent text-rewardsPrimaryColor rounded-none hover:bg-transparent hover:opacity-80`,
  pay: `bg-[#EEE] text-[#2C2E2F] rounded-[4px] min-w-[150px] max-w-[200px] h-[45px] p-[12.5px]`,
  galleryButton: `flex gap-1 justify-center items-center w-fit text-[#030529] text-center text-[12px] bg-[#C9E7FD] hover:bg-[#508BBF] hover:text-white transition-all duration-200 ease-in cursor-pointer rounded-md py-1 px-4 group`,
  filterButton: `py-0.5 flex flex-1 justify-center rounded-[4px] `,
};

// Custom Button
const Button = ({ className = ``, variant = "default", children, ...props }) => {
  return (
    <button
      className={`${variants[variant]} ${commonStyle} ${className}`}
      {...props} // all other passed props like onClick, onHover, etc.
    >
      {children}
    </button>
  );
};

export default React.memo(Button);
